import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import classNames from "classnames";

import "./AlmigButton.css";

const AlmigButton = props => {
	const {
		className,
		...otherProps
	} = props;
	return (
		<Button className={classNames("almig-button", className)} {...otherProps} >
			<FormattedMessage id={props.i18n_key} />
		</Button>
	);
};

AlmigButton.propTypes = {
	className: PropTypes.string,
	i18n_key: PropTypes.string
};

export default AlmigButton;
